export default __webpack_public_path__ + "static/129-2fa9bc8659ef00465b78714e031f79c8.jpg";